import { InputMask } from "primereact/inputmask";
import { InputTextarea } from "primereact/inputtextarea";
import { SelectButton } from "primereact/selectbutton";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import CardSeplag from "../../../../../components/CardSeplag";
import RotuloSeplag from "../../../../../components/RotuloSeplag";

const NewQuestionarioSeplagPrograma = (props) => {
  const [valorSelButton, setValorSelButton] = useState([]);
  const [qtdMaxCaracteres, setQtdMaxCaracteres] = useState(props.qtdMaxCaracteres ? props.qtdMaxCaracteres : null);

  useEffect(() => {
    var posicao = 0;
    var arraytemp = [];

    Array.from(props.campos, function mapFn(element) {
      arraytemp[posicao] = element.data;
      posicao++;
      setValorSelButton(arraytemp);
    });

    let selectButton = document.querySelectorAll(".div-opcao-unica > div");
    selectButton.forEach((element) => {
      const numChildren = element.children.length;
      const numFr = 100 / numChildren;

      element.style.display = "grid";
      element.style.gridTemplateColumns = `repeat(${numChildren},${numFr}fr)`;
    });

    let selectButtonItens = document.querySelectorAll(".div-opcao-unica > div > div");
    selectButtonItens.forEach((element) => {
      element.style.width = "100%";
      element.style.padding = "0.3em 1em";
      element.style.display = "flex";
      element.style.alignItems = "center";
      element.style.justifyContent = "center";
    });
  }, []);

  function setarCampoText(item, chave, texto) {
    item.data = texto;

    let v_campos = props.campos.map((i) => {
      return i.rowId !== item.rowId ? i : item;
    });

    props.setCampos(v_campos);
  }

  const formatarMilhar = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  return (
    <>
      <CardSeplag title={props.titulo} cols={props.cols}>
        {props.campos.map((item, chave) => {
          return (
            props.condicao(item, props.campos) &&
            item.numrPergunta !== "3" && (
              <>
                {item.numrPergunta === "1" && props.renderPPD()}
                {item.numrPergunta === "2" && props.renderCOFD()}
                {item.numrPergunta === "3" && props.renderCEI()}
                <RotuloSeplag
                  nome={item.label}
                  key={item.id}
                  cols={item.cols}
                  obrigatorio={item.flagObrigatorio === "S"}
                >
                  {item.type === "TEXTO" && (
                    <>
                      {item.numrPergunta === "1" && (
                        <span>
                          Dica: PPD indica o êxito (ou não) do planejamento do orçamento quando da elaboração da LOA
                        </span>
                      )}
                      {item.numrPergunta === "2" && (
                        <span>Dica: COFD indica a capacidade de execução financeira do orçamento pelo órgão</span>
                      )}
                      <InputTextarea
                        rows={10}
                        maxLength={qtdMaxCaracteres}
                        cols="120"
                        style={{ width: "100%" }}
                        value={item.data}
                        disabled={props.isDisabled}
                        onChange={(e) => setarCampoText(item, chave, e.target.value)} /*onChange={ setCampos }*/
                        autoResize
                      />
                      {props.IsMaximoCaracteres && (
                        <span className="contador-caracteres">
                          {formatarMilhar(qtdMaxCaracteres - (item.data ? item.data.length : 0))} caracteres restantes
                          <br />
                        </span>
                      )}
                      <br />
                    </>
                  )}
                  {item.type == "OPCAOUNICA" && (
                    <>
                      <div className="div-opcao-unica">
                        <SelectButton
                          value={item.data}
                          options={item.options}
                          optionValue="name"
                          optionLabel="code"
                          disabled={props.isDisabled}
                          /*onChange={(e) => mudarValor(chave, e.value)}*/
                          onChange={(e) => setarCampoText(item, chave, e.target.value)} /*onChange={ setCampos }*/
                        />
                      </div>
                      <br />
                    </>
                  )}
                  {item.type == "DATA" && (
                    <InputMask mask="99/99/9999" slotChar="__/__/____" placeholder="__/__/____" value={item.data} />
                  )}
                  {item.type == "LISTA" && (
                    <>
                      <Dropdown
                        id="idcombobox"
                        placeholder="Selecione uma alternativa"
                        emptyMessage="Dados não encontrados"
                        options={item.options}
                        optionValue="name"
                        optionLabel="code"
                        value={item.data}
                        showClear
                        onChange={(e) => setarCampoText(item, chave, e.target.value)}
                        disabled={props.isDisabled}
                        style={{ minWidth: "200px" }}
                      />
                    </>
                  )}
                </RotuloSeplag>
              </>
            )
          );
        })}
      </CardSeplag>
    </>
  );
};

export default NewQuestionarioSeplagPrograma;
